(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('SupplierController', SupplierController);

    SupplierController.$inject = ['$scope', '$state', 'DataUtils', 'Supplier','NgTableParams'];

    function SupplierController ($scope, $state, DataUtils, Supplier,NgTableParams) {
        var vm = this;
//        vm.supplier = [{code:'AD',name:'Á Đông', typeService:'In giấy giới thiệu trích sao HS bệnh án',userContact:'Anh Trung',phone:'3551 0831',status:'1'},
//                       {code:'BD',name:'In tem Bưu Điện', typeService:'Bao thư cửa sổ phải, bao thư 11x17, giấy tiêu đề tờ 1',userContact:'Anh Đình Hải',phone:'3551 0831',status:'1'},
//                       {code:'BNP',name:'Công ty cổ phần đầu tư DVN', typeService:'Giấy tiêu đề liên tục 2 liên, 3 liên',userContact:'Anh Đình Hải',phone:'3551 0831',status:'1'},
//                       {code:'DVN',name:'Cty Cổ Phần In Tổng Hợp Cần Thơ', typeService:'Sách',userContact:'Anh Trang',phone:'3551 0831',status:'1'},
//                       {code:'FA',name:'In Trần Phú', typeService:'GCN, ĐKHĐ, Bìa Regular & bìa VIP',userContact:'thuylinh@vaikhongdet.vn (094 982 7071 - 0917 548 045)',phone:'3551 0831',status:'1'}];
        vm.supplier = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
        	Supplier.query(function(result) {
                vm.supplier = result;
                if(vm.supplier !=null && vm.supplier.length > 0){
                	var i;
                	for( i = 0; i < vm.supplier.length; i++){
                		if(vm.supplier[i].status == 1){
                			vm.supplier[i].statusName = true;
                		}else{
                			vm.supplier[i].statusName = false;
                		}
                	}
                	vm.tableParams = new NgTableParams({
    					page : 1, // show first page
    					count : 20
    				// count per page
    				}, {
    					filterDelay : 0,
    					dataset : vm.supplier
    				});
                }
            });
        	
        }
    }
})();
